export interface Theme {
  id: string;
  themeClass: string;
  themeName: string;
  themeColor: string;
  themeColorForProfileIcon: string;
  themeColorForNumberKeys: string;
  themeColorForGreenKeys: string;
  themeColorForYellowKeys: string;
  themeColorForNumberBlueKeys: string;
  themeColorForArrowKeysAndControlKeys: string;
  themeColorForControlBar: string;
  themeColorForTopSetOfKeys: string;
  themeColorForAlterKeysPopup: string;
  themeColorForLeftBorderInToolbar: string;
  themeTriangleColorForTopAndGreenKeys: string;
  themeTriangleColorForYellowKeys: string;
  themeTriangleColorForNumberBlueKeys: string;
}

export const THEME_IDS = {
  DEFAULT: 'THEME_01',
  DEFAULT_HIGHCONTRAST: 'THEME_02',
  HIGHT_CONTRAST: 'THEME_03',
  IRLEN: 'THEME_04',
  BRIGHT: 'THEME_05',
};

export const THEMES = [
  {
    id: THEME_IDS.DEFAULT,
    themeClass: 'default',
    themeName: 'Default',
    themeColor: '#1f5773',
    themeColorForProfileIcon: '#3f6586',
    themeColorForNumberKeys: '#D1DDE2',
    themeColorForGreenKeys: '#BDE9B4',
    themeColorForYellowKeys: '#FBCC85',
    themeColorForNumberBlueKeys: '#ACD1E2',
    themeColorForArrowKeysAndControlKeys: '#AACFE1',
    themeColorForControlBar: '#D1DDE2',
    themeColorForTopSetOfKeys: '#D1D3D4',
    themeColorForAlterKeysPopup: '#ffffff',
    themeColorForLeftBorderInToolbar: '#758b9e',

    themeTriangleColorForTopAndGreenKeys: '#6D6E71',
    themeTriangleColorForYellowKeys: '#FF8500',
    themeTriangleColorForNumberBlueKeys: '#00B2F1',
  },
  {
    id: THEME_IDS.DEFAULT_HIGHCONTRAST,
    themeClass: 'default-high-contrast',
    themeName: 'Default High Contrast',
    themeColor: 'teal', //'#4A5A74', //#283593'
    themeColorForProfileIcon: '#005E5E',
    themeColorForNumberKeys: '#E3EDF1',
    themeColorForGreenKeys: '#DBECC7',
    themeColorForYellowKeys: '#FCEDD7',
    themeColorForNumberBlueKeys: '#DFF3FC',
    themeColorForArrowKeysAndControlKeys: '#E4EBF7',
    themeColorForControlBar: '#EEEEEE',
    themeColorForTopSetOfKeys: '#EBECED',
    themeColorForAlterKeysPopup: '#FFFFFF',
    themeColorForLeftBorderInToolbar: '#758b9e',

    themeTriangleColorForTopAndGreenKeys: '#6D6E71',
    themeTriangleColorForYellowKeys: '#FF8500',
    themeTriangleColorForNumberBlueKeys: '#00B2F1',
  },
  {
    id: THEME_IDS.HIGHT_CONTRAST,
    themeClass: 'high-contrast',
    themeName: 'High Contrast',
    themeColor: '#3B3A4F', //'#283593',
    themeColorForProfileIcon: '#414042', //'#0000CE',
    themeColorForNumberKeys: '#ffffff',
    themeColorForGreenKeys: '#ffffff',
    themeColorForYellowKeys: '#ffffff',
    themeColorForNumberBlueKeys: '#ffffff',
    themeColorForArrowKeysAndControlKeys: '#ffffff',
    themeColorForControlBar: '#D1DDE2',
    themeColorForTopSetOfKeys: '#ffffff',
    themeColorForAlterKeysPopup: '#ffffff',
    themeColorForLeftBorderInToolbar: '#ffffff',

    themeTriangleColorForTopAndGreenKeys: '#000000',
    themeTriangleColorForYellowKeys: '#000000',
    themeTriangleColorForNumberBlueKeys: '#000000',
  },

  {
    id: THEME_IDS.IRLEN,
    themeClass: 'Irlen',
    themeName: 'Irlen',
    themeColor: '#D97C36', //'#E36A00', //#4A5A74',
    themeColorForProfileIcon: '#F9B566',
    themeColorForNumberKeys: '#FFEBAA',
    themeColorForGreenKeys: '#F9B566',
    themeColorForYellowKeys: '#FFE985',
    themeColorForNumberBlueKeys: '#FEDA84',
    themeColorForArrowKeysAndControlKeys: '#FEDA84',
    themeColorForControlBar: '#FFE9B4',
    themeColorForTopSetOfKeys: '#FFE085',
    themeColorForAlterKeysPopup: '#FFF6E0',
    themeColorForLeftBorderInToolbar: '#ffffff',

    themeTriangleColorForTopAndGreenKeys: '#FF8500',
    themeTriangleColorForYellowKeys: '#FF8500',
    themeTriangleColorForNumberBlueKeys: '#FF8500',
  },
  {
    id: THEME_IDS.BRIGHT,
    themeClass: 'Bright',
    themeName: 'Bright',
    themeColor: 'Indigo',
    themeColorForProfileIcon: '#3E2666',
    themeColorForNumberKeys: '#F8F9FA',
    themeColorForGreenKeys: '#95E1D3',
    themeColorForYellowKeys: '#FED967',
    themeColorForNumberBlueKeys: '#9CD4FF',
    themeColorForArrowKeysAndControlKeys: '#9CD4FF',
    themeColorForControlBar: '#603B9C',
    themeColorForTopSetOfKeys: '#FFC285',
    themeColorForAlterKeysPopup: '#ffffff',
    themeColorForLeftBorderInToolbar: '#ffffff',

    themeTriangleColorForTopAndGreenKeys: '#6D6E71',
    themeTriangleColorForYellowKeys: '#FF8500',
    themeTriangleColorForNumberBlueKeys: '#00B2F1',
  },
];
/** 
{
  id: THEME_IDS.FOREST,
  themeClass: 'forest',
  themeName: 'Forest',
  themeColor: '#4B0082', //'#2D5A27',
  themeColorForProfileIcon: '#2D5A27',
  themeColorForNumberKeys: '#00FFFF', //'#E8F5E9',
  themeColorForGreenKeys: '#7FFFD4',
  themeColorForYellowKeys: '#D2691E', //'#FFF176',
  themeColorForNumberBlueKeys: '#40E0D0', //'#B3E5FC',
  themeColorForArrowKeysAndControlKeys: '#A5D6A7',
  themeColorForControlBar: '#D1DDE2',
  themeColorForTopSetOfKeys: '#F1F8E9',
  themeColorForAlterKeysPopup: '#2D5A27',
  themeColorForLeftBorderInToolbar: '#ffffff',

  themeTriangleColorForTopAndGreenKeys: '#6D6E71',
  themeTriangleColorForYellowKeys: '#FF8500',
  themeTriangleColorForNumberBlueKeys: '#00B2F1',
},
];
**/
